import { render, staticRenderFns } from "./11zhihuijiaotong.vue?vue&type=template&id=3186cafc&scoped=true&"
import script from "./11zhihuijiaotong.vue?vue&type=script&lang=js&"
export * from "./11zhihuijiaotong.vue?vue&type=script&lang=js&"
import style0 from "./11zhihuijiaotong.vue?vue&type=style&index=0&id=3186cafc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3186cafc",
  null
  
)

export default component.exports